// TODO: (MW) remove this flag per WB-2396
// in the future, consider keeping these type of temporary constants in
// `src/feature-flags` folder

// toggle to true to enable default pagination
// export const HCP_PAGINATION = process.env.HCP_PAGINATION || 'true';

// toggle to false to disable default to pagination
export const HCP_PAGINATION = process.env.HCP_PAGINATION || 'false';

// ----

export const iframePostMessage = {
  LOADED: 'iframe-loaded',
  UPDATE_CONTENT_HEIGHT: 'update_content_height',
  EXPIRED_TOKEN: 'expired_token',
};

export const MFA_ERROR_MSG = 'That code is invalid.';

export const MFA_STATE = {
  MFA_REGISTER: 'MFA_REGISTER',
  MFA_VALIDATE: 'MFA_VALIDATE',
  LOGGED_IN: 'LOGGED_IN',
};

export const IDLE_TIMEOUT_IN_SECONDS = 30 * 60;

export const VERSION_NUMBER = process.env.VERSION_NUMBER || '';
export const BUILD_NUMBER = process.env.BUILD_NUMBER || '';

export const RESET_WEEKS = 13;
export const RESETO_WEEKS = 12;

export const programs = {
  RESET: 'reset',
  RESETO: 'reset-o',
  SOMRYST: 'pear-003',
  PEAR002A: 'pear-002a',
};

export const PROGRAM_CONFIG: {
  [key: string]: { name: string; header: string };
} = {
  [programs.RESET]: { name: 'reSET', header: 'reSET' },
  [programs.RESETO]: { name: 'reSET-O', header: 'reSET-O' },
  [programs.SOMRYST]: { name: 'Somryst', header: 'pear-003' },
  '': { name: 'reSET', header: 'reSET' },
  [programs.PEAR002A]: { name: 'Pear-002a (CTN-100)', header: 'pear-002a' },
};

export const IS_SOMRYST_PATIENT = (currentProgram: string): boolean =>
  currentProgram.toLowerCase() ===
  PROGRAM_CONFIG[programs.SOMRYST].name.toLowerCase();
export const PEAR_PORTAL = 'pearPortal';
export const APP_CONFIG = {
  domain: 'pear.md',
  securityEmail: 'security@peartherapeutics.com',
  optoutEmail: 'optout@peartherapeutics.com',
  legalEmail: 'legal@peartherapeutics.com',
  contactEmail: 'pearconnect@peartherapeutics.com',
};

export const INFINITY = Number.MAX_SAFE_INTEGER;
